export const TYPE_OF_SOP_PAGE = {
  MAIN: 'main',
  SOP: 'sop',
  SOP_PARAMS: 'sop_parameter_page'
};

export const SOP_TYPES = ['critical', 'non_critical', 'none'];
export const PROCESSING_TYPES = [
  'min_value',
  'max_value',
  'true_percentage',
  'false_percentage',
  'average',
  'sentiment',
  'keyword',
  'topic',
  'bucket',
  'average_percentage'
];
export const DESIGN_TYPES = [
  'sop_detail_components',
  'sop_basic_components',
  'sop_sentiment_components',
  'sop_bucket_components',
  'sop_topic_components',
  'sop_keyword_components',
  'sop_detail_with_average_component'
];
export const RELATED_TO_TYPES = ['global', 'agent', 'customer'];
export const PLAYER_COMPONENT_TYPES = [
  'none',
  'data_part_talk_time_metrics',
  'data_part_sentiment_metrics',
  'data_part_topic_and_keywords',
  'data_part_area_of_improvements'
];

export const SOP_TOOLTIPS = {
  NAME: 'Name of sop.',
  SOP_TYPE: 'Type of sop.',
  DESCRIPTION: 'About sop.',
  SOP_FEATURE_TYPE: 'Feature type of sop.',
  TEAM: 'Assign team to this sop.',
  DESIGN_TYPE: 'Design type of sop. Based on this value component will be displayed in analytics page.',
  RELATED_TO: 'Sop related to which?',
  PLAYER_COMPONENT: 'Based on this value tabs will be included in evaluation player page beside transcript.',
  PROCESSING_TYPE: 'Based on this value data will be processed.',
  IS_INCLUDE_IN_CQ: 'This value will decide whether this sop should be included in CQ score calculation or not.',
  IS_FILTER: 'This value will decide whether sop should be displayed in filters of scorecard page and evaluation page.',
  IS_ENABLED: 'Active/Inactive',
  IS_REVERSED: 'Based on this the range value will be changed from Low-High/High-Low.',
  PARTS_RANGE_VALUE: 'By this we can set the range values.'
};

export const MENUPROPS = {
  //Multiselect dropdown popup style
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250
    }
  }
};
